import React, { useEffect, useState, useRef } from "react";
//import { useState } from "react";
import SearchComponent from "../Search/SearchComponent/SearchComponent";
//import { Link } from 'react-router-dom';
import "./tramites.css";
import { tramitesyservicios } from "../../json/tramitesyservicios";

const Tramites = () => {
  const [search, setSearch] = useState("");
  const searchInput = useRef();
  var tramitesyserv = "";
  tramitesyserv = JSON.stringify(tramitesyservicios);
  tramitesyserv = JSON.parse(tramitesyserv);

  const searchTram = () => {
    tramitesyserv = JSON.stringify(tramitesyservicios);
    tramitesyserv = JSON.parse(tramitesyserv);
    setSearch(searchInput.current.value);
  };

  let filterTram = tramitesyserv.filter((tramite) => {
    let tramites = tramite.tramites_array;
    if (!tramite.tramite_loc.toLowerCase().includes(search.toLowerCase())) {
      tramite.tramites_array = tramites.filter((tramiteDet) => {
        return tramiteDet.tramite_item_nombre
          .toLowerCase()
          .includes(search.toLowerCase());
      });
    }
    if (
      tramite.tramites_array.length > 0 ||
      tramite.tramite_loc.toLowerCase().includes(search.toLowerCase())
    ) {
      return tramite;
    }
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="container transparencia-container">
      <div className="row">
        <div className="col-12">
          <div className="transparencia_title">
            <h1>Trámites y Servicios</h1>
          </div>
        </div>
      </div>
      <SearchComponent
        searchInput={searchInput}
        search={search}
        searchTram={searchTram}
      />
      <div className="row">
        {filterTram.map((item, index) => (
          <div key={index} className="col-12 tramite_item">
            <h1 className="tramite_title">{item.tramite_loc}</h1>
            <hr className="tramitehr" />
            <div className="tramites-container">
              <ul>
                {" "}
                {item.tramites_array.map((tram, i) => (
                  <li>
                    {" "}
                    <a
                      target="{_blank}"
                      key={i}
                      href={tram.transparencia_item_url}
                    >
                      {tram.tramite_item_nombre}
                    </a>{" "}
                  </li>
                ))}{" "}
              </ul>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Tramites;
